function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.52 8.21902C10.76 7.97902 11.138 7.96002 11.4 8.16402L11.462 8.21902L13.685 10.443C13.925 10.683 13.945 11.061 13.741 11.323L13.685 11.385L11.462 13.609C11.202 13.869 10.78 13.869 10.519 13.609C10.279 13.369 10.261 12.99 10.464 12.729L10.519 12.666L12.271 10.914L10.52 9.16202C10.26 8.90202 10.26 8.48002 10.52 8.21902ZM2.666 10.247H9.824C10.193 10.247 10.491 10.546 10.491 10.914C10.491 11.256 10.234 11.538 9.902 11.576L9.824 11.581H2.667C2.298 11.581 2 11.282 2 10.914C2 10.572 2.257 10.29 2.589 10.252L2.667 10.247H9.825H2.667H2.666Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.19502 5.08499L4.41802 2.86199C4.67802 2.60199 5.10102 2.60199 5.36102 2.86199C5.60102 3.10199 5.62002 3.47999 5.41702 3.74199L5.36102 3.80499L3.61002 5.55699L5.36002 7.30899C5.62002 7.56899 5.62002 7.99099 5.36002 8.25099C5.12002 8.49099 4.74102 8.51099 4.48002 8.30699L4.41702 8.25099L2.19402 6.02799C1.95402 5.78799 1.93602 5.40899 2.13902 5.14799L2.19402 5.08499L4.41702 2.86199L2.19402 5.08499H2.19502ZM6.05502 4.88999H13.215C13.582 4.88999 13.881 5.18799 13.881 5.55699C13.881 5.89799 13.624 6.17999 13.292 6.21899L13.214 6.22299H6.05402C5.68702 6.22299 5.38802 5.92499 5.38802 5.55699C5.38802 5.21499 5.64602 4.93299 5.97802 4.89399L6.05502 4.88999H13.215H6.05502Z",
  fill: "currentColor"
});

function SvgArrowTransfer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowTransfer);
export default __webpack_public_path__ + "static/media/arrow-transfer.289db767.svg";
export { ForwardRef as ReactComponent };